export default __webpack_public_path__ + "/dist/images/termcondition-active.svg";